import React from "react";
import "./styles/ListingTable.css";
import { MdOutgoingMail } from "react-icons/md";
import { useTranslation } from "react-i18next";
import "../../localisation/index"

const ResendGiftCard = ({ data, resendMail }) => {
  const {t} = useTranslation()
  return (
    <table className="listing-table resend-table">
      <thead>
        <tr>
          <th>{t("commonTexts.order")}</th>
          <th>{t("commonTexts.date")}</th>
          <th>{t("commonTexts.customer")}</th>
          <th>{t("commonTexts.action")}</th>
        </tr>
      </thead>

      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            <td>#{row?.order_number}</td>
            <td>{row?.created_at?.slice(0, 10)}</td>
            <td>{row?.customer?.first_name}</td>
            <td className="gc-table__actions">
              <MdOutgoingMail
                className="gc-table-icons"
                style={{ height: "23px", width: "23px" }}
                onClick={() => resendMail(row?.id)}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ResendGiftCard;
